import React, { useState } from 'react';
import AdPlatformsSection from '../sections/AdPlatformsSection';
import SeoMetricsSection from '../sections/SeoMetricsSection';
import CompetitorInsights from '../sections/CompetitorInsights';
import { CompetitorData } from '../../types/dataTypes';

interface DashboardLayoutProps {
  data: CompetitorData;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ data }) => {
  const [activeTab, setActiveTab] = useState('all');

  const tabs = [
    { id: 'all', label: 'Overview' },
    { id: 'ads', label: 'Ad Platforms' },
    { id: 'seo', label: 'SEO Metrics' },
    { id: 'insights', label: 'Insights' },
  ];

  return (
    <div className="mt-8">
      <div className="border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex space-x-4 overflow-x-auto pb-1 sm:space-x-8">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm sm:text-base transition-colors duration-200
                ${activeTab === tab.id 
                  ? 'border-blue-500 text-blue-600 dark:text-blue-400' 
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:border-gray-600'}
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      <div className="py-6">
        {(activeTab === 'all' || activeTab === 'ads') && (
          <div className={`${activeTab !== 'all' ? '' : 'mb-12'}`}>
            <AdPlatformsSection data={data} />
          </div>
        )}
        
        {(activeTab === 'all' || activeTab === 'seo') && (
          <div className={`${activeTab !== 'all' ? '' : 'mb-12'}`}>
            <SeoMetricsSection data={data} />
          </div>
        )}
        
        {(activeTab === 'all' || activeTab === 'insights') && (
          <div>
            <CompetitorInsights data={data} />
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardLayout;